import React, { useEffect, useState } from "react";
import SliderLatestCollections from "../../components/Common/Slider/SliderLatestCollections/SliderLatestCollections";
import ReLoASection from "../../components/Features/ReLoASection/ReLoASection";
import LatestReleases from "../../components/Features/LatestReleases/LatestReleases";
import { hostURL } from "../../services/data_requests";
import ReUploadArchive from "../../components/Features/ReUploadArchive/ReUploadArchive";
import { Image77 } from "../../assets";
import ReArtworkSection from "../../components/Features/ReArtworkSection/ReArtworkSection";
import { fetchCollections } from "../../components/Features/Market/Market";

const Home = () => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await fetchCollections();
        setCollections(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const funooniTabs = [
    {
      label: "Our effort",
      title: "Art with a story. Proof that lasts.",
      content: `Welcome to Funooni - a platform for authenticated physical editions of art, heritage, and cultural memory from across the Middle East and North Africa. We work with artists, archives, and rights holders to bring meaningful artworks into the physical world as editions made to be collected, gifted, and kept. From historic posters and archival photography to contemporary art, every Funooni work carries a story, a clear edition, and verifiable provenance. Discover art that connects the past and present - and find a piece worth carrying forward.`,
    },
    {
      label: "Verification",
      title:
        "Verification Layers of Physical Artworks",
      content: `We use a multi-layered verification system to establish the authenticity of physical artworks and track their history over time. The system combines physical documentation, digital records and blockchain technology, with each layer providing a different type of information and verification.`,
      button: {
        text: "Learn More",
        link: "/verification",
        variant: "link",
      },
    },
    {
      label: "Meet Our Artist",
      title: "Meet our artists",
      content: `Where we transform valuable physical artworks into unique digital assets, secured and authenticated via blockchain. Here, you can buy and sell these exclusive digital pieces, expanding your collection and engaging with a community of art lovers.- here u need to add navigation button`,
      button: {
        text: "Discover",
        onClick: () => console.log("Navigate to artists"),
      },
    },
  ];

  return (
    <div className="home">
      <div className="marketCover2">
        <SliderLatestCollections />
      </div>

      <ReLoASection tabs={funooniTabs} />

      <LatestReleases
        title="Latest Releases"
        subtitle="Discover the latest releases from our artists"
        apiURL={hostURL + "artwork?count=50&offset=0"}
        count={7}
      />

      <ReUploadArchive
        image={Image77}
        title="Our Initiative for Reconstructing Historical Records"
        content={`Our historical project is a global digital archive dedicated to preserving and reimagining historical and cultural heritage. Through restored imagery, archival materials, and visual reconstructions, it brings forgotten moments of everyday life, cities, traditions, and societies back into the present.

By combining historical research with modern technology, the archive transforms fragile records into accessible, verifiable, and lasting digital artifacts. Decentralized storage and blockchain infrastructure ensure authenticity, transparency, and long-term preservation beyond institutional or geographic boundaries.

The project serves as a living cultural memory - a space for exploration, research, and discovery, where history is not only preserved, but experienced.`}
      />

      <ReArtworkSection
        title="Historical Reproduction | Egypt | – World Chronicles"
        subtitle="Explore countries, their history and culture "
        collectionName="Egypt"
      />

      <ReArtworkSection
        title="Historical Reproduction | Palestine | – Cities"
        subtitle="Sacred Architecture and Spiritual Life"
        collectionName="cities"
        collections={collections}
      />

      <ReArtworkSection
        title="Historical Reproduction | Palestine | – Historical Ads"
        subtitle="Commercial Life and Visual Culture"
        collectionName="Historical Ads"
        collections={collections}
      />
    </div>
  );
};

export default Home;
